import React, { useState } from "react";
import {
    Card,
    Typography,
    Box,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Avatar,
    IconButton,
    Collapse,
    Divider,
    useMediaQuery
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { useQueryWithStore } from "react-admin";
import jwt_decode from "jwt-decode";
import { Link } from "react-router-dom";
import CardIcon from "./CardIcon";

const getBranchCode = () => {
    try {
        return localStorage.token ? jwt_decode(localStorage.token).branch_code : "";
    } catch (error) {
        console.error("Invalid token:", error);
        return "";
    }
};

const DeferralList = () => {
    const branch_code = getBranchCode();

    const { data: donors, loaded } = useQueryWithStore({
        type: "getList",
        resource: "deferralexp",
        payload: {
            filter: { branch_code },
            sort: { field: "name", order: "DESC" },
            pagination: { page: 1, perPage: 100 },
        },
    });

    if (!loaded) return null;
    if (!donors?.length) return <Typography sx={{  p: 2, fontSize: 14 }}>No deferrals expiring soon.</Typography>;

    return (
        <List sx={{ width: "100%" }}>
            {donors.map((record, index) => (
                <React.Fragment key={record.id}>
                    <ListItem
                        button
                        component={Link}
                        to={`/donors/${record.id}/show`}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            p: 1.5,
                            "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.05)" },
                        }}
                    >
                        <ListItemText
                            primary={record.name.toUpperCase()}
                            primaryTypographyProps={{ sx: { fontSize: "12px" } }}
                        />
                    </ListItem>
                    {index < donors.length - 1 && <Divider />}
                </React.Fragment>
            ))}
        </List>
    );
};

const GetDeferralCount = () => {
    const branch_code = getBranchCode();

    const { data: donors, loaded } = useQueryWithStore({
        type: "getList",
        resource: "deferralexp",
        payload: {
            filter: { branch_code },
            sort: { field: "name", order: "DESC" },
            pagination: { page: 1, perPage: 100 },
        },
    });

    if (!loaded) return null;
    return donors?.length || 0;
};

const DeferralCom = () => {
    const [isOpen, setIsOpen] = useState(false);
    const isTablet = useMediaQuery("(max-width: 1024px)");  // Detects iPad-sized screens

    return (
        <Box sx={{ width: "100%", maxWidth: isTablet ? "90%" : 700, p: 0 }}>
            <Card 
                sx={{ 
                    width: "100%", 
                    minWidth: 350, 
                    maxWidth: "100%", 
                    borderRadius: 2, 
                    boxShadow: 3, 
                    p: 1, 
                    overflow: "hidden" 
                }}
            >
                <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                    <Box display="flex" alignItems="center" gap={1}>
                        <CardIcon Icon={PersonIcon} bgColor="navy" />
                        <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "14px" }}>
                            Deferral Expires Soon (<GetDeferralCount />)
                        </Typography>
                    </Box>
                    <IconButton 
                        onClick={() => setIsOpen(!isOpen)} 
                        sx={{ fontSize: isTablet ? "24px" : "inherit" }} // Larger button for touch screens
                    >
                        {isOpen ? "▲" : "▼"}
                    </IconButton>
                </Box>
                <Collapse in={isOpen} sx={{ width: "100%" }}>
                    <Divider sx={{ my: 1 }} />
                    <DeferralList />
                </Collapse>
            </Card>
        </Box>
    );
};

export default DeferralCom;
